<template>
  <div class="album page">
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    name: 'Album',
    props: {},
    components: {},
    watch: {},
    data () {
      return {}
    }
  }
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/pages/album/Album.vue